module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"note.empty":"ไม่มี Note สำหรับ {name} นี้","note.update":"ปรับ Note นี้","note.clear":"ล้างค่า Note นี้","note.modal.title":"Drone Note Editor"}}')
  delete Component.options._Ctor
}
